import Login from "@/pages/Login.vue";
import Home from "@/pages/Home.vue";
import Dashboard from "@/pages/Dashboard.vue";
import Register from "@/pages/Register.vue";
import RegisterConfirmation from "@/pages/RegisterConfirmation.vue";
import ConfirmEmail from "@/pages/account/ConfirmEmail.vue";
import ForgotPassword from "@/pages/account/ForgotPassword.vue";
import ResetPassword from "@/pages/account/ResetPassword.vue";
import UserProfile from "@/pages/account/UserProfile.vue";
import ChangePassword from "@/pages/account/ChangePassword.vue";
import Order from "@/pages/Order.vue";
import Search from "@/pages/Search.vue";
import RegisterPartnerNation from "@/pages/RegisterPartnerNation.vue"
import AdminUsersDashboard from "@/pages/admin/users/Index.vue";
import UserAuditLogs from "@/pages/admin/users/AuditLogs.vue";
import AdminUsersModificationsDashboard from "@/pages/admin/user-modifications/Index.vue";
import AdminOrderReassignmentDashboard from "@/pages/admin/order-reassignment/Index.vue";

import AdvancedSearchPage from "@/pages/admin/users/AdvancedSearch.vue"
import AdminUserProfile from "@/pages/admin/users/Edit.vue";
import AdminUserModificationsProfile from "@/pages/admin/user-modifications/Edit.vue";
import AdminTransactionsDashboard from "@/pages/admin/transactions/Index.vue";
import AdminEditTransaction from "@/pages/admin/transactions/Edit.vue";
import AdminOrganizationsDashboard from "@/pages/admin/organizations/Index.vue";
import AdminOperationTheaterDashboard from "@/pages/admin/theaters/Index.vue";
import AdminFinanceOfficesDashboard from "@/pages/admin/finance-offices/Index.vue";
import AdminBankingOfficesDashboard from "@/pages/admin/banking-offices/Index.vue";
import AdminAcsaDashboard from "@/pages/admin/acsas/Index.vue";
import ToolTipDashboard from "@/pages/admin/tool-tip/Index.vue";
import PartnerNation from "@/pages/admin/partner-nation/Index.vue";
import ViewAcsas from "@/pages/admin/viewACSAs/Index.vue";

import AdminEditAcsa from "@/pages/admin/acsas/Edit.vue";
import AdminEditAcsaFiles from "@/pages/admin/acsas/EditAcsaFiles.vue";
import EditIaFiles from "@/pages/admin/acsas/EditIaFiles.vue";
import Notifications from "@/pages/Notifications.vue";
import DevelopmentTools from "@/pages/admin/DevelopmentTools.vue";
import CreateReport from "@/pages/reports/CreateReport.vue";
import OverDueReport from "@/pages/reports/OverDueReport.vue";
import RequestedAuthorization from "@/pages/reports/FmrRequestedAuthorization.vue";
//import Insights from "@/pages/reports/Insights.vue";

import FAQs from "@/pages/FAQs.vue";

import SuperUserAdminUsers from "@/pages/super-admin/Users.vue";
import SuperUserFaqs from "@/pages/super-admin/Faqs.vue";
import SuperUserEmailExtensions from "@/pages/super-admin/EmailExtension.vue";
import SuperUserAdminOrder from "@/pages/super-admin/Order.vue";
import SuperUserOrganizationHierarchy from "@/pages/super-admin/OrganizationHierarchy.vue";

import GenerateAcsaPage from "@/pages/GenerateAcsaPage.vue";
import ImportAcsa from "@/pages/ImportACSA.vue";
import Order13A from "@/pages/templates/Order13A.vue";
import CreditReports from "@/pages/reports/CreditReports.vue";
import CountrySummary from "@/pages/reports/CountrySummary.vue";
import FMRReport from "@/pages/reports/FMRReport.vue";


import store from "../store/store";

export const routes = [
  {
    path: "/Login",
    name: "Login",
    meta: {
      title: "Welcome to AGATRS"
    },
    component: Login,
  },
  {
    path: "/Notifications",
    name: "Notifications",
    meta: {
      title: "Notifications",
    },
    component: Notifications,
      beforeEnter: (to, from, next) => {
      if (store.getters["authentication/isLoggedIn"]) {
        next();
      } else {
        next({
          path: "/login",
        });
      }
    },
  },
  {
    path: "/secret/development-tools",
    name: "DevelopmentTools",
    component: DevelopmentTools,
    meta: {
      title: "DevelopmentTools",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else {
        next();
      }
    },
  },
  {
    path: "/secret/users",
    name: "Users",
    component: SuperUserAdminUsers,
    meta: {
      title: "Users",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (store.getters["authentication/isSuperAdmin"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/secret/faqs",
    name: "FAQ",
    component: SuperUserFaqs,
    meta: {
      title: "FAQ",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if (store.getters["authentication/isSuperAdmin"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/secret/hierarchy",
    name: "OrganizationHierarchy",
    component: SuperUserOrganizationHierarchy,
    meta: {
      title: "Organization Hierarchy",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      }else 
      if (store.getters["authentication/isSuperAdmin"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },

  {
    path: "/secret/email-extensions",
    name: "Email Extensions",
    component: SuperUserEmailExtensions,
    meta: {
      title: "Email Extensions",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if (store.getters["authentication/isSuperAdmin"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/FAQs",
    name: "FAQs",
    meta: {
      title: "FAQs",
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isPartnerAccount"] && store.getters["authentication/isLoggedIn"]) {
        next();
      } else {
        next({
          path: "/login",
        });
      }
    },
    component: FAQs,
  },
  {
    path: "/Register",
    name: "Register",
    meta: {
      title: "AGATRS Registration",
    },
    component: Register,
  },
  
  {
    path: "/Account/UserProfile",
    name: "UserProfile",
    meta: {
      title: "User Profile",
    },
     beforeEnter: (to, from, next) => {
      if (store.getters["authentication/isLoggedIn"]) {
        next();
      } else {
        next({
          path: "/login",
        });
      }
    },
    component: UserProfile,
  },
  {
    path: "/RegisterConfirmation",
    name: "RegisterConfirmation",
    meta: {
      title: "Register Confirmation",
    },
    component: RegisterConfirmation,
  },
  {
    path: "/Account/ConfirmEmail",
    name: "ConfirmEmail",
    meta: {
      title: "Confirm Email",
    },
    component: ConfirmEmail,
  },
  {
    path: "/Account/ForgotPassword",
    name: "ForgotPassword",
    meta: {
      title: "Forgot Password",
    },
    
    component: ForgotPassword,
  },
  {
    path: "/Account/ResetPassword",
    name: "ResetPassword",
    meta: {
      title: "Reset Password",
    },
    component: ResetPassword,
  },
  {
    path: "/Account/ChangePassword",
    name: "ChangePassword",
    meta: {
      title: "Change Password",
    },
    component: ChangePassword,
  },
  {
    path: "/RegisterPartnerNation/:countryId",
    name: "RegisterPartnerNation",
    meta: {
      title: "AGATRS Register Partner Nation",
    },
    component: RegisterPartnerNation,
  },
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "AGATRS: Home",
    },
  },
  {
    path: "/admin/users",
    name: "AdminUsersDashboard",
    component: AdminUsersDashboard,
    meta: {
      title: "AGATRS: Admin Users",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      }
      else if (
        (store.getters["authentication/isSponsor"] ||
          store.getters["authentication/isOUSD"]) &&
        !store.getters["authentication/isPartnerAccount"]
      ) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/admin/user-modifications",
    name: "AdminUsersModificationsDashboard",
    component: AdminUsersModificationsDashboard,
    meta: {
      title: "AGATRS: Admin Users Modifications",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if ((store.getters["authentication/isSuperAdmin"])
      ) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/admin/orderReassignment",
    name: "AdminOrderReassignmentDashboard",
    component: AdminOrderReassignmentDashboard,
    meta: {
      title: "AGATRS: Admin Orders Reassignment",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if (store.getters["authentication/isSuperAdmin"]
      ) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  // AdminOrderReassignmentDashboard
  {
    path: "/admin/superadminorder",
    name: "SuperUserAdminOrder",
    component: SuperUserAdminOrder,
    meta: {
      title: "AGATRS: Super Admin Page",
      requiresAuth: true
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      }else 
      if(
      (store.getters["authentication/isSuperAdmin"])) {
        next();
      } else {
        next({
          path: "/dashboard"
        });
      }
    }
  },
  {
    path: "/admin/users/AdvancedSearch",
    name: "User Advanced Search",
    component: AdvancedSearchPage,
    meta: {
      title: "AGATRS: Admin Users",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else 
      if (store.getters["authentication/isSponsor"] || store.getters["authentication/isOUSD"] && !store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/admin/profile/:id",
    name: "AdminUserProfile",
    component: AdminUserProfile,
    meta: {
      title: "AGATRS: User Profile",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (store.getters["authentication/isSponsor"] || store.getters["authentication/isOUSD"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/admin/audit-logs/:id",
    name: "UserAuditLogs",
    component: UserAuditLogs,
    meta: {
      title: "AGATRS: User Audit Logs",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (store.getters["authentication/isSponsor"] || store.getters["authentication/isOUSD"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/admin/profiles/:id",
    name: "AdminUserModificationsProfile",
    component: AdminUserModificationsProfile,
    meta: {
      title: "AGATRS: User Modifications Profile",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (store.getters["authentication/isSuperAdmin"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/admin/transactions",
    name: "AdminTransactionsDashboard",
    component: AdminTransactionsDashboard,
    meta: {
      title: "AGATRS: Admin Transactions Dashboard",
    },
    beforeEnter: (to, from, next) => {
      if(!store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      }else
      if (store.getters["authentication/isSponsor"] && !store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/CreateReport",
    name: "CreateReport",
    component: CreateReport,
    meta: {
      title: "AGATRS: Create Report",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {

      if(!store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } 
      else if (!store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/overduereport",
    name: "OverDueReport",
    component: OverDueReport,
    meta: {
      title: "AGATRS: ACSA Overdue Report",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if(!store.getters["authentication/isLoggedIn"]){
         next({
          path: "/login",
        });
      }
      else if (!store.getters["authentication/isPartnerAccount"] ) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
 
  {
    path: "/admin/transactions/view/:id",
    name: "AdminViewTransaction",
    component: AdminEditTransaction,
    meta: {
      title: "AGATRS: Edit Transaction",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (store.getters["authentication/isSponsor"] && !store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/admin/transactions/:id",
    name: "AdminEditTransaction",
    component: AdminEditTransaction,
    meta: {
      title: "AGATRS: Edit Transaction",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (store.getters["authentication/isSponsor"] && !store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/admin/organizations",
    name: "AdminOrganizationsDashboard",
    component: AdminOrganizationsDashboard,
    meta: {
      title: "AGATRS: Admin Organizations Dashboard",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if (store.getters["authentication/isSponsor"] && !store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/admin/theaters",
    name: "OperationTheaterTab",
    component: AdminOperationTheaterDashboard,
    meta: {
      title: "AGATRS: Admin Operation Theater Tab",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if (store.getters["authentication/isSponsor"] && !store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
 
  {
    path: "/Admin/FinanceOffices",
    name: "AdminFinanceOfficesDashboard",
    component: AdminFinanceOfficesDashboard,
    meta: {
      title: "AGATRS: Admin Finance Offices Dashboard",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if (store.getters["authentication/isSponsor"] && !store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/Admin/BankingOffices",
    name: "AdminBankingOfficesDashboard",
    component: AdminBankingOfficesDashboard,
    meta: {
      title: "AGATRS: Admin Banking Offices Dashboard",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if (store.getters["authentication/isSponsor"] && !store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/Admin/ToolTip",
    name: "ToolTipDashboard",
    component: ToolTipDashboard,
    meta: {
      title: "AGATRS: Admin Tool Tip Dashboard",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if (store.getters["authentication/isSuperAdmin"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/Admin/PartnerNation",
    name: "PartnerNationPage",
    component: PartnerNation,
    meta: {
      title: "AGATRS: Admin Partner Nation Dashboard",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if( !store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      } else
      if (
        store.getters["authentication/isSuperAdmin"] 
      ) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/admin/ACSAs",
    name: "AdminACSAsDashboard",
    component: AdminAcsaDashboard,
    meta: {
      title: "AGATRS: Admin ACSAs Dashboard",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if(!store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        })
      }else

      if (!store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
  },
  {
    path: "/admin/viewACSAs",
    name: "ViewAcsas",
    component: ViewAcsas,
    meta: {
      title: "AGATRS: View ACSAs Dashboard",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (!store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/admin/ACSAs/:id",
    name: "AdminEditACSA",
    component: AdminEditAcsa,
    meta: {
      title: "AGATRS: Edit ACSA",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (!store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/Admin/ACSAFiles/:id",
    name: "AdminEditACSAFiles",
    component: AdminEditAcsaFiles,
    meta: {
      title: "AGATRS: Edit ACSA Files",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (!store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/Admin/IAFiles/:id",
    name: "AdminEditIAFiles",
    component: EditIaFiles,
    meta: {
      title: "AGATRS: Edit IA Files",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
      } else if (!store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({ path: "/dashboard" });
      }
    },
  },
  {
    path: "/order/edit/:id",
    name: "Order",
    meta: {
      title: "AGATRS Orders",
      requiresAuth: true,
    },
    component: Order,
    props: true,
    beforeEnter: (to, from, next) => {
      if (to.params.id == 0) {
       if (store.getters["authentication/isLogistics"]) {
          next();
        } else {
          next({ path: "/dashboard" });
        }
      } else {
        if(!store.getters["authentication/isLoggedIn"]){
           next({ path: "/login" });
        }
        store.dispatch("orderMetadata/getOrderMetadata", to.params.id).then(() => {
          if(store.getters["orderUsers/isOrderCompleted"]) {
            next({ path: `/order/view/${to.params.id}` });
          }
          // if it is pn user
          // check pn user permission
          if(store.getters["authentication/isPartnerAccount"]) {
            let d = store.getters["orderMetadata/orderMetadata"];
            // compare to partnernation user country
            var self = store.getters['authentication/getUser'];
            var countries = self['countries'];
            var orderCountryId = d['countryId'];
            if(!countries.includes(orderCountryId)){
              next({
                path: "/dashboard",
              });
            } 
          }
        })
        store
          .dispatch("orderUsers/getUserEditibility", to.params.id)
          .then(() => {
            if (store.getters["orderUsers/canUserEditOrder"]) {
              store.dispatch("orderMetadata/updateViewOnlyStatus", false);
              next();
            } else {
              store.dispatch("orderMetadata/updateViewOnlyStatus", true);
              next({ path: `/order/view/${to.params.id}` });
            }
          });
      }
    },
  },
  {
    path: "/order/view/:id",
    name: "ViewOrder",
    meta: {
      title: "AGATRS Orders",
      requiresAuth: true,
    },
    component: Order,
    props: true,
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({ path: "/login" });
        return;
      }
      store
        .dispatch("orderMetadata/getOrderMetadata", to.params.id)
        .then(() => {
          // if it is pn user
          // check pn user permission
          if(store.getters["authentication/isPartnerAccount"]) {
            let d = store.getters["orderMetadata/orderMetadata"];
            // compare to partnernation user country
            var self = store.getters['authentication/getUser'];
            var countries = self['countries'];
            var orderCountryId = d['countryId'];
            if(!countries.includes(orderCountryId)){
              next({ path: "/dashboard" });
              return;
            }
          }

          store.dispatch("orderMetadata/updateViewOnlyStatus", true);
          next();
        });
    },
  },
  // SR: Route for Importing ASCA Orders
  {
    path: "/import/order",
    name: "ImportACSA",
    meta: {
      title: "Import ACSA Orders",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
          if (store.getters["authentication/isLoggedIn"]) {
            next();
          } else {
            next({
              path: "/login",
            });
          }
        },
    component: ImportAcsa,
  },
  // {
  //   path: "/reports/:type",
  //   name: "Reports",
  //   meta: {
  //     title: "AGATRS Reports",
  //     requiresAuth: true,
  //   },
  //   component: Reports,
  // },
  {
    path: "/reports/countrysummary",
    name: "Country Summary",
    meta: {
      title: "AGATRS Country Summary",
      requiresAuth: true,
      buyOrSell: 'SELL'
    },
    beforeEnter: (to, from, next) => {
      if (!store.getters["authentication/isLoggedIn"]) {
        next({
          path: "/login",
        });
      } else {
        next();
      }
    },
    component: CountrySummary
  },
  {
    path: "/reports/creditreports",
    name: "Credit Report",
    meta: {
      title: "AGATRS Credit Reports",
      requiresAuth: true,
      buyOrSell: 'SELL'
    },
    beforeEnter: (to, from, next) => {
      if(!store.getters["authentication/isLoggedIn"]){
        next({
          path: "/login",
        });
      }
      else if (!store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
    component: CreditReports
  }, //FMRReport
  {
    path: "/reports/FMRReport",
    name: "Liability Report",
    meta: {
      title: "AGATRS Liability Reports",
      requiresAuth: true,
      buyOrSell: 'BUY'
    },
    beforeEnter: (to, from, next) => {
        if(!store.getters["authentication/isLoggedIn"]){
 next({
          path: "/login",
        });
      }
      else 
      if (!store.getters["authentication/isPartnerAccount"]) {
        next();
      } else {
        next({
          path: "/dashboard",
        });
      }
    },
    component: FMRReport
  }, //FMRReport
    {
        path: "/reports/requestedauthorization",
        name: "FMR Requested Authorization",
        meta: {
            title: "AGATRS FMR Reports",
            requiresAuth: true,
        },
        beforeEnter: (to, from, next) => {
        if(!store.getters["authentication/isLoggedIn"]){
          next({
          path: "/login",
        });
      }
      else 
          if (!store.getters["authentication/isPartnerAccount"]) {
            next();
          } else {
            next({
              path: "/dashboard",
            });
          }
        },
        component: RequestedAuthorization,
    },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      title: "AGATRS: Dashboard",
      requiresAuth: true,
    },
    beforeEnter: (to, from, next) => {
          if (store.getters["authentication/isLoggedIn"]) {
            next();
          } else {
            next({
              path: "/login",
            });
          }
        },
  },
  //{
  //  path: "/insights",
  //  name: "Insights",
  //  component: Insights,
  //  meta: {
  //    title: "AGATRS: Insights",
  //    requiresAuth: true,
  //  },
  //},
  {
    path: "/search",
    name: "Search",
    component: Search,

        meta: {
            title: "Search",
        },
        beforeEnter: (to, from, next) => {
            if(!store.getters["authentication/isLoggedIn"]){
 next({
          path: "/login",
        });
      }
      else 
          
          if (!store.getters["authentication/isPartnerAccount"]) {
            next();
          } else {
            next({
              path: "/dashboard",
            });
          }
        },
        
    },
    {
        path: "/GenerateACSAPage/:id",
        name: "GenerateACSAPage",
        component: GenerateAcsaPage,
        meta: {
            title: "GenerateACSAPage",
            requiresAuth: true,
        },
        beforeEnter:(to, from,next)=> {
          if(store.getters["authentication/isLoggedIn"]){
            next();
          }else{
            next({path : "/login"});
          }
        },
        props: true,
    },
    {
        path: "/order/13a/:id",
        name: "Order13A",
        component: Order13A,
        meta: {
            title: "Order13A",
            requiresAuth: true,
        },
         beforeEnter:(to, from,next)=> {
          if(store.getters["authentication/isLoggedIn"]){
            next();
          }else{
            next({path : "/login"});
          }
        },
        props: true,
    },
];
